import { onCLS, onINP, onLCP, onFCP, onTTFB, type Metric } from 'web-vitals';
import * as amplitude from '@amplitude/analytics-browser';

/**
 * Core Web Vitals tracking.
 *
 * Metrics are sent to Amplitude via `web_vital` events and logged in
 * development for local debugging. Values are rounded to reduce cardinality
 * and to avoid exposing overly precise timing data. No PII is included.
 */

const rating = (m: Metric) => m.rating; // 'good' | 'needs-improvement' | 'poor'

const send = (metric: Metric) => {
  const value =
    metric.name === 'CLS' ? Math.round(metric.value * 1000) / 1000 : Math.round(metric.value);

  const payload = {
    metric_name: metric.name,
    metric_value: value,
    metric_rating: rating(metric),
    metric_id: metric.id,
    navigation_type: metric.navigationType,
    path: typeof window !== 'undefined' ? window.location.pathname : undefined,
  };

  try {
    amplitude.track('web_vital', payload);
  } catch {
    // Amplitude may not be initialized (no key) — ignore silently.
  }

  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.log(`[web-vitals] ${metric.name}`, value, rating(metric));
  }
};

let installed = false;

export const initWebVitals = () => {
  if (installed || typeof window === 'undefined') return;
  installed = true;

  onCLS(send);
  onINP(send);
  onLCP(send);
  onFCP(send);
  onTTFB(send);
};
